import { useMemo } from 'react';

import { Permission } from '@/api/permissions';
import { CatalogGroup } from '@/shared/modules/role-board/types';
import { augmentCatalogGroups } from '@/utils/permission-catalog';

export type UseAugmentedCatalogGroupsArgs = {
  groups: readonly CatalogGroup[] | undefined;
  present: ReadonlySet<Permission>;
};

export const useAugmentedCatalogGroups = ({
  groups,
  present,
}: UseAugmentedCatalogGroupsArgs): CatalogGroup[] =>
  useMemo(() => augmentCatalogGroups(groups ?? [], present), [groups, present]);
